// extracted by mini-css-extract-plugin
export var boxItems = "_b5-1";
export var boxItemsLg = "_b5-2";
export var button = "_b5-7";
export var buttonHoverless = "_b5-9";
export var buttonLg = "_b5-8";
export var filterGroupBox = "_b5-0";
export var icon = "_b5-3";
export var iconSecondary = "_b5-6";
export var iconWrapper = "_b5-4";
export var iconWrapperLg = "_b5-5";
export var truncatedLabel = "_b5-a";